import React, { useState, useEffect } from 'react';

import { CalendarClickableAffix } from '../styles';
import CalendarButtonIcon from './CalendarButtonIcon';

export interface CalendarButton {
  calendarOpen: boolean;
  setCalendarOpen: (calendarOpen: boolean) => void;
  disabled?: boolean;
  invalid?: boolean;
}

function CalendarButton(props: CalendarButton) {
  const { calendarOpen, setCalendarOpen, disabled, invalid } = props;

  const [hasTheCalendarOpened, setHasTheCalendarOpened] = useState(false);

  useEffect(() => {
    if (calendarOpen && !hasTheCalendarOpened) {
      setHasTheCalendarOpened(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calendarOpen]);

  return (
    <CalendarClickableAffix
      disabled={disabled}
      invalid={invalid}
      calendarOpen={calendarOpen}
      onClick={() => setCalendarOpen(!calendarOpen)}
      as="button"
      type="button"
      theme={{ seam: 'left' }}
      aria-label={`${calendarOpen ? 'Close' : 'Open'} the calendar`}
    >
      <CalendarButtonIcon hasTheCalendarOpened={hasTheCalendarOpened} disabled={disabled} calendarOpen={calendarOpen} />
    </CalendarClickableAffix>
  );
}

export default CalendarButton;
